// extracted by mini-css-extract-plugin
module.exports = {"stat":"style_stat__rPMYn","stat-number":"style_stat-number__uWOo_","stat-description":"style_stat-description__YHwGY"};